import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Sun2 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M11.0003 2.44772V1.81421M11.0003 20.186V19.5524M19.5527 11.0001H20.1862M1.81445 11.0001H2.44796M17.0483 4.95272L17.4963 4.50476M4.50434 17.4954L4.9523 17.0475M17.0483 17.0474L17.4963 17.4954M4.50434 4.50472L4.9523 4.95267M16.056 10.9654C16.056 13.7645 13.787 16.0335 10.988 16.0335C8.18893 16.0335 5.91988 13.7645 5.91988 10.9654C5.91988 8.16642 8.18893 5.89737 10.988 5.89737C13.787 5.89737 16.056 8.16642 16.056 10.9654Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
})

export default Sun2
